import { FC } from 'react'
import { useTranslate } from 'react-admin'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import { ConditionNodeData, WorkflowNodeData } from '../types'
import ExpressionTextField from '../autocomplete/ExpressionTextField'

interface ConditionConfigProps {
  data: ConditionNodeData
  onUpdate: (data: Partial<WorkflowNodeData>) => void
}

const ConditionConfig: FC<ConditionConfigProps> = ({ data, onUpdate }) => {
  const translate = useTranslate()
  const assertTruthy = Boolean(data.assertTruthy)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label={translate('workflow.config.label')}
        value={data.label}
        onChange={(e) => onUpdate({ label: e.target.value })}
        size="small"
        fullWidth
      />
      <ExpressionTextField
        label={translate('workflow.config.expression')}
        value={data.expression}
        onChange={(e) => onUpdate({ expression: e.target.value })}
        size="small"
        fullWidth
        multiline
        rows={3}
        placeholder="{{ nodes.prev.output.type }} == 'melding'"
      />
      <Box>
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={assertTruthy}
              onChange={(e) => onUpdate({ assertTruthy: e.target.checked })}
            />
          }
          label={translate('workflow.config.assertTruthy')}
        />
        <Typography variant="caption" sx={{ display: 'block', color: 'rgba(0,0,0,0.6)', mt: -0.5 }}>
          {translate('workflow.config.assertTruthyHelp')}
        </Typography>
      </Box>
      {assertTruthy && (
        <ExpressionTextField
          label={translate('workflow.config.assertError')}
          value={data.assertError ?? ''}
          onChange={(e) => onUpdate({ assertError: e.target.value })}
          size="small"
          fullWidth
          multiline
          rows={2}
          placeholder={translate('workflow.config.assertErrorPlaceholder')}
        />
      )}
    </Box>
  )
}

export default ConditionConfig
